import * as rest from './RestUtil';
import { IHandlerData } from '../util/DataModelInterface';
import { getFunctionBaseUrl } from './RestUrls';

export const getHandlerData = async (sorter: string, types: string[], startDate: string, endDate: string) => {
  const type = types.join('+');
  const url = `${getFunctionBaseUrl()}/api/getHandlerData/${sorter}/${type}/${startDate}/${endDate}`;
  const response: IHandlerData[] = await rest.get(url);
  return response;
}

/**
 * @param sorterID
 * @param reportingPeriod "MM-YYYY"
 */
export const sendHandlerReportData = async (sorterID: string, reportingPeriod: string, json: any[]) => {
  const url = `${getFunctionBaseUrl()}/api/SortreportInsert/${sorterID}/${reportingPeriod}`
  const response = await rest.post(url, json);
  return response;
}